import { ChakraProvider } from '@chakra-ui/react';
import { Provider as ReduxProvider } from 'react-redux';
import { RouterProvider } from 'react-router';

import { DefaultProvider } from '@burnsred/default';

import { DebugResponsive, ScrollArea, Toaster } from '@/components';
import defaults from '@/defaults';
import router from '@/routes';
import { settings } from '@/settings';
import setup from '@/setup';
import { store } from '@/store';
import { system } from '@/theme';

setup(settings);

export function App() {
  return (
    <ReduxProvider store={store}>
      <DefaultProvider {...defaults}>
        <ChakraProvider value={system}>
          <ScrollArea>
            <RouterProvider router={router} />
            <Toaster />
            {import.meta.env.DEV && <DebugResponsive />}
          </ScrollArea>
        </ChakraProvider>
      </DefaultProvider>
    </ReduxProvider>
  );
}
